<template>
    <div>
        <ob1-input-chips
            v-if="selectedStatus"
            id="chip-status-id"
            additional-classes="mb-1 me-1"
            :label="selectedStatus.primaryText"
            @ob1-input-chips-click="deleteStatusHandler(selectedStatus)"
        />
        <template v-if="filtersBrand">
            <span v-for="brand in filtersBrand.checkboxes" :key="brand.id">
                <ob1-input-chips
                    v-if="brand.isChecked"
                    :id="'chip-' + brand.id"
                    additional-classes="mb-1 me-1"
                    :label="brand.label"
                    @ob1-input-chips-click="deleteBrandHandler(brand)"
                />
                <span v-for="range in brand.ranges" :key="range.id">
                    <ob1-input-chips
                        v-if="range.isChecked"
                        :id="'chip-' + range.id"
                        additional-classes="mb-1 me-1"
                        :label="range.label"
                        @ob1-input-chips-click="deleteRangeHandler(range, brand, false)"
                    />
                </span>
            </span>
        </template>
        <template v-if="filtersRefurbishedBrand">
            <span v-for="brand in filtersRefurbishedBrand.checkboxes" :key="'refurbished-' + brand.id">
                <ob1-input-chips
                    v-if="brand.isChecked"
                    :id="'chip-' + brand.id"
                    :key="brand.id"
                    additional-classes="mb-1 me-1"
                    :label="brand.label + ' reconditionnés'"
                    @ob1-input-chips-click="deleteBrandRefurbishedHandler(brand)"
                />
                <span v-for="range in brand.ranges" :key="range.id">
                    <ob1-input-chips
                        v-if="range.isChecked"
                        :id="'chip-' + range.id"
                        additional-classes="mb-1 me-1"
                        :label="range.label + ' reconditionnés'"
                        @ob1-input-chips-click="deleteRangeHandler(range, brand, true)"
                    />
                </span>
            </span>
        </template>
        <template v-if="filtersPrice">
            <span v-for="price in filtersPrice.checkboxes" :key="price.id">
                <ob1-input-chips
                    v-if="price.isChecked"
                    :id="'chip-' + price.id"
                    :key="price.id"
                    additional-classes="mb-1 me-1"
                    :label="price.label"
                    @ob1-input-chips-click="deletePriceHandler(price)"
                />
            </span>
        </template>
        <template v-if="filtersRepairability">
            <span v-for="repairability in filtersRepairability.checkboxes" :key="repairability.id">
                <ob1-input-chips
                    v-if="repairability.isChecked"
                    :id="'chip-' + repairability.id"
                    :key="repairability.id"
                    additional-classes="mb-1 me-1"
                    :label="getRepairabilityChipLabel(repairability)"
                    @ob1-input-chips-click="deleteRepairabilityHandler(repairability)"
                />
            </span>
        </template>
        <template v-if="filtersCompatibility">
            <span v-for="compatibility in filtersCompatibility.checkboxes" :key="compatibility.id">
                <ob1-input-chips
                    v-if="compatibility.isChecked"
                    :id="'chip-' + compatibility.id"
                    :key="compatibility.id"
                    additional-classes="mb-1 me-1"
                    :label="compatibility.label"
                    @ob1-input-chips-click="deleteCompatibilityHandler(compatibility)"
                />
            </span>
        </template>
        <template v-if="filtersSegments">
            <span v-for="segment in filtersSegments.checkboxes" :key="segment.id">
                <ob1-input-chips
                    v-if="segment.isChecked"
                    :id="'chip-' + segment.id"
                    :key="segment.id"
                    additional-classes="mb-1 me-1"
                    :label="segment.label"
                    @ob1-input-chips-click="deleteSegmentHandler(segment)"
                />
            </span>
        </template>
        <template v-if="filtersRefurbishedSegments">
            <span v-for="segment in filtersRefurbishedSegments.checkboxes" :key="segment.id">
                <ob1-input-chips
                    v-if="segment.isChecked"
                    :id="'chip-' + segment.id"
                    :key="segment.id"
                    additional-classes="mb-1 me-1"
                    :label="segment.label"
                    @ob1-input-chips-click="deleteRefurbishedSegmentHandler(segment)"
                />
            </span>
        </template>
        <template v-if="filtersOtherSegments">
            <span v-for="segment in filtersOtherSegments.checkboxes" :key="segment.id">
                <ob1-input-chips
                    v-if="segment.isChecked"
                    :id="'chip-' + segment.id"
                    :key="segment.id"
                    additional-classes="mb-1 me-1"
                    :label="segment.label"
                    @ob1-input-chips-click="deleteOtherSegmentHandler(segment)"
                />
            </span>
        </template>
        <ob1-liens-icone
            v-if="displayDeleteAllChipsFilterLink"
            mini
            :is-button="true"
            icon="icon-trash"
            :title="deleteChipsFiltersLabel"
            class="noDefaultStyleButton mb-1 py-0"
            @click="deleteAllChipsFilterHandler"
        />
    </div>
</template>

<script>


export default {
    name: "SelectorChipsFilter",
    props: {
       filters: {
            type: Array,
            required: true
        },
        selectedStatus: {
            type: Object,
            required: false,
            default: null
        },
        deleteChipsFiltersLabel: {
            type: String,
            required: true
        }
    },
    computed: {
        filtersSegments() {
            return this.filters.find(filter => filter.id === "segments-filter")
        },
        filtersRefurbishedSegments() {
            return this.filters.find(filter => filter.id === "refurbished-segments-filter")
        },
        filtersOtherSegments() {
            return this.filters.find(filter => filter.id === "other-segments-filter")
        },
        filtersPrice() {
            return this.filters.find(filter => filter.id === "price-filter")
        },
        filtersRepairability() {
            return this.filters.find(filter => filter.id === "repairability-filter")
        },
        filtersBrand() {
            return this.filters.find(filter => filter.id === "brand-filter")
        },
        filtersRefurbishedBrand() {
            return this.filters.find(filter => filter.id === "brand-refurbished-filter")
        },
        filtersCompatibility() {
            return this.filters.find(filter => filter.id === "compatibility-filter")
        },
        displayDeleteAllChipsFilterLink() {
            return this.filters.map(
                filter => filter.checkboxes.some(checkbox => checkbox.isChecked)
            ).some(isChecked => isChecked) || this.selectedStatus !== null;
        }
    },
    methods: {
        deleteAllChipsFilterHandler() {
            this.$emit('delete-all-chips-filter')
        },
        deleteBrandHandler: function (brand) {
            this.updateTms("Marque", brand.label)
            this.$emit('change-chips-filter', this.filtersBrand.id, brand.id)
        },
        deleteBrandRefurbishedHandler: function (brand) {
            this.updateTms("Marque Reconditionnée", brand.label)
            this.$emit('change-chips-filter', this.filtersRefurbishedBrand.id, brand.id)
        },
        deleteRangeHandler: function (range, brand, refurbished) {
            this.updateTms("Gamme", range.label)
            this.$emit('delete-range-filter', range.id, brand.id, refurbished)
        },
        deletePriceHandler: function (price) {
            this.updateTms("Prix", price.label)
            this.$emit('change-chips-filter', this.filtersPrice.id, price.id)
        },
        deleteRepairabilityHandler: function (repairability) {
            this.updateTms("Indice de réparabilité", repairability.label)
            this.$emit('change-chips-filter', this.filtersRepairability.id, repairability.id)
        },
        deleteSegmentHandler: function (segment) {
            this.updateTms("Notre sélection", segment.label)
            this.$emit('change-chips-filter', this.filtersSegments.id, segment.id)
        },
        deleteRefurbishedSegmentHandler: function (segment) {
            this.updateTms("Coups de coeur reconditionnes", segment.label)
            this.$emit('change-chips-filter', this.filtersRefurbishedSegments.id, segment.id)
        },
        deleteOtherSegmentHandler: function (segment) {
            this.updateTms("Segment", segment.label)
            this.$emit('change-chips-filter', this.filtersOtherSegments.id, segment.id)
        },
        deleteCompatibilityHandler: function (compatibility) {
            this.updateTms("Compatibilité", compatibility.label)
            this.$emit('change-chips-filter', this.filtersCompatibility.id, compatibility.id)
        },
        deleteStatusHandler: function (statusFilter) {
            Tms.link({
                category: "selecteur_produit",
                action: stripAccents(statusFilter.primaryText).split(' ').join('_'),
                label: "choix_filtre_Etat"
            })
            this.$emit('delete-status-filter', statusFilter.radioButtonDTO.id)

        },
        getRepairabilityChipLabel(repairability) {
            const repairabilityPrefix = 'Indice de réparabilité';
            const repairabilityLabels = {
                '0.0-6.9': 'moyen',
                '7.0-7.9': 'bon',
                '8.0-8.9': 'très bon',
                '9.0-10.0': 'excellent'
            };

            const specificDescriptor = repairabilityLabels[repairability.id];
            return specificDescriptor ? `${repairabilityPrefix} ${specificDescriptor}` : '';
        },
        updateTms(label, filterLabel){
            Tms.link({
                category: "selecteur_produit",
                action: stripAccents(filterLabel).split(' ').join('_'),
                label: "choix_filtre_" + stripAccents(label).split(' ').join('_')
            })
        }
    },
}
</script>
